// @flow

// Libs
import React from 'react'

// Constants
import { CONTACT_US } from '../constants'

import { Link } from 'react-router-dom'

// Styles
import { primary } from 'hfty-styles/src/colors'

const styles = {
  container: {
    boxShadow: '0 1px 1px rgba(0, 0, 0, 0.1)',
    padding: 5,
    textAlign: 'center',
    backgroundColor: primary(),
  },
  linkStyle: {
    textDecoration: 'none',
    color: '#fff',
    fontSize: 12,
  },
}

// Types
type Props = {
  isAuthenticated: boolean,
}

export default function BottomBar(props: Props): ?React.Element<any> {
  if (!props.isAuthenticated) {
    return null
  }

  return (
    <div style={styles.container}>
      <Link style={{ ...styles.linkStyle, paddingRight: '20px' }} to={'/privacy-policy'}>
        Privacy Policy
      </Link>
      <Link style={styles.linkStyle} to={CONTACT_US}>
        Need Help? Contact Us
      </Link>
    </div>
  )
}
